// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.justify-content {
  justify-content: center;
}

.overflow {
  overflow: visible;
}

.ag-row {
  display: flex;
  justify-content: center;
  align-items: center;
}

.ag-row .ag-cell.photo-column .ag-selection-checkbox, .ag-row .ag-cell.photo-column {
  display: inline-block;
}

.ag-cell-value {
  display: flex;
  align-items: center;
  height: 100%;
}

.ag-cell-value {
  height: 100%;
}

.ag-row .ag-cell.file-column .ag-cell-wrapper {
  display: flex;
}

.center-align {
  text-align: center;
}

.capitalize-column-content{
  text-transform: capitalize;
}

.photo-column {
  min-height: 60px;
}

.notes-cell {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.notes-cell > div {
  width: 100%;
  height: 100%;
  position: relative;
}

.deals-cell > div {
  position: relative;
  width: 100%;
}

.ag-header-cell-label .ag-header-cell-text {
  white-space: initial !important;
  line-height: 16px;
  display: flex;
  align-items: center;
}

.ag-theme-balham .ag-header-cell::after {
  height: 30px;
}

.ag-header-cell-menu-button {
  position: relative;
  top: 7px;
}

.deals-name-column {
  min-height: 60px;
}

.ag-overlay {
  position: relative;
  height: 140px;
}

.ag-theme-balham .ag-ltr .ag-row-group-leaf-indent {
  margin-left: 0;
}

.ag-paging-panel > span {
  color: black !important;
}

.ag-root-wrapper {
  position: relative !important;
  overflow: initial;
}

.ag-paging-panel {
  position: absolute !important;
  top: -45px !important;
  right: 0 !important;
  border-top: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/overrides/ag-grid.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;AAC7B","sourcesContent":[".justify-content {\n  justify-content: center;\n}\n\n.overflow {\n  overflow: visible;\n}\n\n.ag-row {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ag-row .ag-cell.photo-column .ag-selection-checkbox, .ag-row .ag-cell.photo-column {\n  display: inline-block;\n}\n\n.ag-cell-value {\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n\n.ag-cell-value {\n  height: 100%;\n}\n\n.ag-row .ag-cell.file-column .ag-cell-wrapper {\n  display: flex;\n}\n\n.center-align {\n  text-align: center;\n}\n\n.capitalize-column-content{\n  text-transform: capitalize;\n}\n\n.photo-column {\n  min-height: 60px;\n}\n\n.notes-cell {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n.notes-cell > div {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.deals-cell > div {\n  position: relative;\n  width: 100%;\n}\n\n.ag-header-cell-label .ag-header-cell-text {\n  white-space: initial !important;\n  line-height: 16px;\n  display: flex;\n  align-items: center;\n}\n\n.ag-theme-balham .ag-header-cell::after {\n  height: 30px;\n}\n\n.ag-header-cell-menu-button {\n  position: relative;\n  top: 7px;\n}\n\n.deals-name-column {\n  min-height: 60px;\n}\n\n.ag-overlay {\n  position: relative;\n  height: 140px;\n}\n\n.ag-theme-balham .ag-ltr .ag-row-group-leaf-indent {\n  margin-left: 0;\n}\n\n.ag-paging-panel > span {\n  color: black !important;\n}\n\n.ag-root-wrapper {\n  position: relative !important;\n  overflow: initial;\n}\n\n.ag-paging-panel {\n  position: absolute !important;\n  top: -45px !important;\n  right: 0 !important;\n  border-top: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
